<template >
  <div class="pyro">
    <canvas id="canvas"></canvas>
  </div>
</template>
<script>
export default {
// https://codepen.io/yshlin/pen/ylDEk?css-preprocessor=scss
  name: 'Fireworks',
  /* eslint-disable*/
  methods: {
    fire() {
      const ctx = canvas.getContext('2d');
      const w = document.body.clientWidth;
      const h = document.body.clientHeight;
      canvas.width = w;
      canvas.height = h;

      const nodes = [];

      function draw() {
        requestAnimationFrame(draw);

        ctx.globalCompositeOperation = 'destination-out';
        ctx.fillStyle = 'rgba(0, 0, 0, .08)';
        ctx.fillRect(0, 0, w, h);

        ctx.globalCompositeOperation = 'lighter';

        let l = nodes.length; let
          node;
        while (l--) {
          node = nodes[l];
          drawNode(node);
          if (node.dead) {
            nodes.splice(l, 1);
          }
        }

        if (nodes.length < 10) {
          l = rand(4, 1) | 0;
          while (l--) {
            nodes.push(makeNode(
              Math.random() * w | 0,
              Math.random() * h | 0,
              40,
              `hsl(${rand(300, 0) | 0}, 100%, 90%)`,
              100,
            ));
          }
        }
      }

      function drawNode(node) {
        let l = node.children.length;
        let point;
        while (l--) {
          point = node.children[l];
          ctx.beginPath();
          ctx.fillStyle = point.color;
          ctx.arc(point.x, point.y, 1, 0, PI2);
          ctx.fill();
          ctx.closePath();
          updatePoint(point);
          if (point.dead) {
            node.children.splice(l, 1);
            if (node.count > 20) {
              nodes.push(makeNode(
                point.x,
                point.y,
                node.radius * 10,
                node.color,
                (node.count / 10) | 0,
              ));
            }
          }
        }
        if (!node.children.length) {
          node.dead = true;
        }
      }

      function updatePoint(point) {
        const dx = point.x - point.dx;
        const dy = point.y - point.dy;
        const c = Math.sqrt(dx * dx + dy * dy);
        point.dead = c < 1;
        point.x -= dx * point.velocity;
        point.y -= dy * point.velocity;
      }

      const rad = Math.PI / 180;
      const PI2 = Math.PI * 2;
      let ttt = 0;

      function rand(max, min) {
        min = min || 0;
        return Math.random() * (max - min) + min;
      }

      function makeNode(x, y, radius, color, partCount) {
        radius = radius || 0;
        partCount = partCount || 0;
        const count = partCount;

        const children = [];
        let kof;
        let r;
        while (partCount--) {
          kof = 100 * Math.random() | 0;
          r = radius * Math.random() | 0;
          children.push({
            x,
            y,
            dx: x + r * Math.cos(ttt * kof * rad),
            dy: y + r * Math.sin(ttt * kof * rad),
            color,
            velocity: rand(1, 0.05),
          });
          ttt++;
        }

        return {
	  radius,
          count,
          color,
          x,
          y,
          children,
        };
      }

      draw();
    },
    fireHandler() {
      this.fire();
      window.addEventListener('resize', () => {
        this.fire();
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.pyro {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
canvas {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
